import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AccumulationCalculationSingle } from "../../../../employment/employmentApi";
import { formatPartitionKeyDisplayValue } from "../helpers";
import { StyledTableCell } from "../styles";
import { SingleCalculationRowHeader } from "../types";

type Props = {
  value: AccumulationCalculationSingle;
};

const AccumulationsTableSingleCalculationTable = ({ value }: Props) => {
  const { t } = useTranslation("talentProfile");

  // do not show completedLimits in the table
  const headers: SingleCalculationRowHeader[] = [
    { key: "partitionKey", label: t("accumulationKeys.valueDate") },
    { key: "workTime", label: t("accumulationKeys.workTimeSingle") },
  ];

  return (
    <StyledTableCell>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <StyledTableCell key={header.key} align="right">
                {header.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={value.partitionKey}>
            <StyledTableCell align="right">
              {formatPartitionKeyDisplayValue(value.partitionKey)}
            </StyledTableCell>
            <StyledTableCell align="right">
              {value.workTime || "0"}
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </StyledTableCell>
  );
};

export default AccumulationsTableSingleCalculationTable;
